import { isWebview } from './deviceDetection'

/**
 * 傳送訊息給 app 端（iOS 或 Android）。
 *
 * @param {Object} data - 欲傳送的資料物件，會自動轉換為 JSON 字串。
 * @returns {boolean} 是否成功呼叫對應的 postMessage handler。
 *
 * 注意：
 * - data 參數必須為物件，函式會自動幫你做 JSON.stringify。
 * - 若傳入非物件，將不會送出並顯示警告。
 * - 僅於 WebView 環境下才會傳送訊息。
 * - 傳送訊息給原生 App（WebView 專用，支援 iOS/Android）。
 * - 僅接受物件型別資料。
 */
export const postMessage = (data) => {
  if (typeof data !== 'object' || data === null) {
    console.warn('postMessage: data 必須為物件且不可為 null')
    return false
  }
  const jsonData = JSON.stringify(data)

  try {
    // iOS WebView
    if (isWebview() && window?.webkit?.messageHandlers?.cordova_iab) {
      window.webkit.messageHandlers.cordova_iab.postMessage(jsonData)
      return true
    }
    // Android WebView
    if (isWebview() && window?.cordova_iab) {
      window.cordova_iab.postMessage(jsonData)
      return true
    }
    console.warn('No available postMessage handler')
    return false
  } catch (error) {
    console.log(error)
    return false
  }
}

export const checkPostMessageAvailable = () => {
  // SSR 環境無 window，直接回傳 false 避免 ReferenceError
  if (typeof window === 'undefined') return false
  return isWebview() && (window.webkit?.messageHandlers?.cordova_iab || window.cordova_iab)
}

// 提供預設匯出，避免外部使用 default import 時取得 undefined
export default {
  postMessage,
  checkPostMessageAvailable
}
